const userPreferenceReducer = (
    state = {
      data: {}
    },
    action: {
      type: "SET_USER_PREFERENCE";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_USER_PREFERENCE":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default userPreferenceReducer;